import { SVGProps } from 'react'

export const ProfilePencilIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32rem"
      height="32rem"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80 26.59C4.43 28.01 5.87 29.23 7.21 28.63L12.30 26.34C13.48 25.82 13.70 24.24 12.71 23.41L9.03 20.30C8.05 19.47 6.54 19.95 6.21 21.19L4.80 26.59ZM6.60 27.26C6.41 27.35 6.20 27.17 6.25 26.97L7.66 21.57C7.71 21.39 7.93 21.33 8.07 21.45L11.75 24.56C11.89 24.68 11.85 24.90 11.69 24.98L6.60 27.26ZM10.03 17.82L21.68 4.05C21.77 3.94 21.93 3.93 22.04 4.02L26.61 7.89C26.72 7.98 26.73 8.13 26.64 8.24L14.99 22.01L16.14 22.98L27.79 9.21C28.41 8.47 28.32 7.37 27.58 6.74L23.01 2.87C22.27 2.25 21.16 2.34 20.54 3.08L8.89 16.85L10.03 17.82Z"
        fill="url(#paint0_linear_1493_7485)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.77 19.32L22.01 7.21L23.16 8.18L12.92 20.29L11.77 19.32Z"
        fill="url(#paint1_radial_1493_7485)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1493_7485"
          x1="3.55"
          y1="29.30"
          x2="25.23"
          y2="2.02"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.32" stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_1493_7485"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.40 7.85) rotate(131.08) scale(16.69 6.95)"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </radialGradient>
      </defs>
    </svg>
  )
}
